import create from './create/texts.js';
import add from './list/texts.js';

export default {
  create,
  add,
  buttons: {
    copyToCart: {
      notes: 'Title of copy to cart button',
      message: 'Copy to cart',
    },
    moveToCart: {
      notes: 'Title of move to cart button',
      message: 'Move to cart',
    },
  },
  action: {
    addShoppingList: {
      notes: 'Menu action for adding items to a new or existing shopping list',
      message: 'Add to shopping list',
    },
  },
  dialogs: {
    remove: {
      title: {
        notes: 'Title of remove shopping list dialog',
        message: 'Remove shopping list',
      },
      content: {
        notes: 'Content of remove shopping list dialog',
        message: 'Are you sure you want to remove {{shoppingListTopic}}?',
      },
    },
    duplicate: {
      title: {
        notes: 'Title of duplicate shopping list dialog',
        message: 'Duplicate shopping list',
      },
    },
    addTo: {
      title: {
        add: {
          notes: 'Dialog title when adding to an existing shopping list',
          message: 'Add to shopping list',
        },
        new: {
          notes: 'Dialog title when creating a new shopping list',
          message: 'New shopping list',
        },
      },
      tabs: {
        existing: {
          notes: 'Title on tab for choosing an existing shopping list',
          message: 'Existing shopping list',
        },
        new: {
          notes: 'Title on tab for creating a new shopping list',
          message: 'New shopping list',
        },
      },
    },
  },
  model: {
    topic: {
      notes: 'Title of topic field',
      message: 'Topic',
    },
    messageField: {
      notes: 'Title of message field',
      message: 'Message',
    },
    equipment: {
      notes: 'Title of equipment field',
      message: 'Equipment',
    },
    itemCount: {
      notes: 'Title of no of articles parameter',
      message: 'Articles',
    },
    type: {
      title: {
        notes: 'Title of shopping list type field',
        message: 'Type',
      },
      options: {
        wishlist: {
          notes: 'Wishlist option title',
          message: 'Wishlist',
        },
        template: {
          notes: 'Template option title',
          message: 'Template',
        },
      },
      help: {
        notes: 'Little i helptext for shopping list type',
        message:
          'A template is a list that can be re-used if needed while a wishlist most often is used once',
      },
    },
  },
  details: {
    empty: {
      action: {
        notes: 'Text on back button',
        message: 'Back to shopping lists',
      },
      text: {
        notes: 'Text when shopping list is not found',
        message: 'The content you are looking for could not be found',
      },
    },
    sections: {
      articles: {
        title: {
          notes: 'Title of articles section',
          message: 'Articles',
        },
      },
      information: {
        title: {
          notes: 'Title of information section',
          message: 'Information',
        },
        sections: {
          general: {
            title: {
              notes: 'Title of general information section',
              message: 'General information',
            },
          },
        },
      },
      contributors: {
        title: {
          notes: 'Title of contributors section',
          message: 'Contributors',
        },
        users: {
          email: {
            header: {
              notes: 'User column for E-mail address',
              message: 'E-mail address',
            },
          },
          role: {
            header: {
              notes: 'User column for contributor role',
              message: 'Role',
            },
            placeholder: {
              notes: 'Placeholder text when selecting role',
              message: 'Select role',
            },
            values: {
              admin: {
                notes: 'DisplayName for role admin',
                message: 'Admin',
              },
              editor: {
                notes: 'DisplayName for role editor',
                message: 'Editor',
              },
              viewer: {
                notes: 'DisplayName for role viewer',
                message: 'Viewer',
              },
            },
          },
        },
        help: {
          notes: 'Little i helptext Contributors accordion header',
          message:
            'To share this list with someone in the organization, please add them below',
        },
      },
    },
  },
  changeLog: {
    title: {
      notes: 'Title of contributors changelog',
      message: 'Contribution history',
    },
    model: {
      createdAt: {
        notes: 'Title of createdAt field',
        message: 'Date',
      },
      contributorEmail: {
        notes: 'Title of contributor email field',
        message: 'Contributor',
      },
      changeLog: {
        notes: 'Title of changeLog field',
        message: 'Logged event',
      },
    },
  },
  notifications: {
    successfullyAdded: {
      notes:
        'Toast message indicating an item (or items) was successfully added to a shopping list',
      message: {
        zero: '',
        one: '{{displayName}} added to shopping list',
        other: '{{count}} items added to shopping list',
      },
    },
    successfullyCreated: {
      notes: 'Toast message when a shopping list was successfully created',
      message: 'Shopping list created successfully',
    },
  },
};
